import { useMemo } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { themeSettings } from 'theme';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Routing from 'Routing';

import { useSelector } from 'react-redux';
import { NavProvider } from 'context/NavContext';

function App() {
    const mode = useSelector((state) => state.auth.mode);
    const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

    return (
        <div className="App">
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                <NavProvider>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />
                        {/*<Router>
                            <Routing/>
                        </Router>*/}
                            <Routing />
                    </ThemeProvider>
                </NavProvider>
            </GoogleOAuthProvider>
        </div>
    );
}

export default App;
